import { Box, Button, Typography } from '@mui/material'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { useEffect } from 'react'
import { EditIcon } from 'src/v3/core/icons'
import {
  selectSelectedLinkedService,
  fetchLinkedServiceRoster,
  selectLinkedServiceRosterByID,
  selectLinkedServiceRosterStatusByID,
  selectLinkedServiceById,
} from '../admin.slice'

export default ({ setFormOpen }: { setFormOpen: (arg: string) => void }) => {
  let dispatch = useAppDispatch()
  let selectedLinkedService = useAppSelector(selectSelectedLinkedService)
  let linkedServiceRoster = useAppSelector(
    selectLinkedServiceRosterByID(selectedLinkedService),
  )
  let linkedServiceRosterStatus = useAppSelector(
    selectLinkedServiceRosterStatusByID(selectedLinkedService),
  )
  let linkedService = useAppSelector(
    selectLinkedServiceById(selectedLinkedService),
  )

  useEffect(() => {
    if (
      selectedLinkedService &&
      (!linkedServiceRosterStatus ||
        linkedServiceRosterStatus === 'uninitialized')
    ) {
      dispatch(fetchLinkedServiceRoster(selectedLinkedService))
    }
  }, [selectedLinkedService, linkedServiceRosterStatus])

  return (
    <Box className="w-full mt-4">
      <Typography
        variant="body2"
        color="textSecondary"
        sx={{ fontWeight: 600 }}
      >
        Total Users
      </Typography>
      <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
        {linkedServiceRoster?.length ?? 0}
      </Typography>
      <Box className="flex items-center">
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{ fontWeight: 600 }}
        >
          User Cap
        </Typography>
        <Button
          variant="text"
          size="small"
          onClick={() => setFormOpen('user-cap')}
          sx={{ minWidth: 'auto', p: 0.5, ml: 1 }}
        >
          <EditIcon sx={{ fontSize: 16 }} />
        </Button>
      </Box>
      <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
        {linkedService?.userCap || 'None'}
      </Typography>
    </Box>
  )
}
